import {text_mod_16, } from "../text/Text.js";
export const module16 = {
  title:
    "Урок 16, 17. Зв’язок множення і ділення. Правило множення на 0. Правило ділення на 0. Назви компонентів під час ділення.​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_16, },
    ]
  }
